/* IC moments: one moment open at a time; its picture + card show on the right.
   Optional auto-advance (data-icm-auto = ms per moment) runs only while the section is on screen,
   and stops for good once someone picks a moment. Reduced motion: no auto-advance. */
(() => {
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (root.dataset.icmReady) return;
    root.dataset.icmReady = '1';
    const items = [...root.querySelectorAll('[data-icm-item]')];
    const slides = [...root.querySelectorAll('[data-icm-slide]')];
    if (!items.length) return;
    let current = Math.max(0, items.findIndex(i => i.classList.contains('is-open')));
    const ms = parseInt(root.dataset.icmAuto || '0', 10);
    let auto = ms > 0 && !reduce.matches && items.length > 1;
    let timer = null, visible = false;

    const show = i => {
      current = i;
      items.forEach((el, n) => {
        const on = n === i;
        el.classList.toggle('is-open', on);
        el.querySelector('.icm__trigger').setAttribute('aria-expanded', on ? 'true' : 'false');
        // Restart the progress line
        const bar = el.querySelector('.icm__progress');
        if (bar && on) { bar.style.animation = 'none'; void bar.offsetWidth; bar.style.animation = ''; }
      });
      slides.forEach((s, n) => {
        const on = n === i;
        s.classList.toggle('is-active', on);
        on ? s.removeAttribute('aria-hidden') : s.setAttribute('aria-hidden', 'true');
        s.querySelectorAll('a').forEach(a => on ? a.removeAttribute('tabindex') : a.setAttribute('tabindex', '-1'));
      });
    };

    const schedule = () => {
      clearTimeout(timer);
      if (!auto || !visible) return;
      timer = setTimeout(() => { show((current + 1) % items.length); schedule(); }, ms);
    };
    const stopAuto = () => { auto = false; clearTimeout(timer); root.classList.remove('is-auto', 'is-paused'); };

    if (auto) { root.style.setProperty('--icm-ms', ms + 'ms'); root.classList.add('is-auto', 'is-paused'); }

    items.forEach((el, n) => el.querySelector('.icm__trigger').addEventListener('click', () => { stopAuto(); show(n); }));

    if (auto && 'IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        visible = e.isIntersecting;
        root.classList.toggle('is-paused', !visible);
        if (visible) show(current); // restart the progress line with the timer
        schedule();
      }, { threshold: 0.35 }).observe(root);
      document.addEventListener('visibilitychange', () => {
        if (!auto) return;
        document.hidden ? clearTimeout(timer) : (visible && (show(current), schedule()));
      });
    }

    // Theme editor: selecting a block opens it
    root.addEventListener('shopify:block:select', e => {
      const n = items.findIndex(i => i.contains(e.target) || i === e.target);
      if (n > -1) { stopAuto(); show(n); }
    });
  }

  const boot = () => document.querySelectorAll('[data-icm]').forEach(init);
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  document.addEventListener('shopify:section:load', boot);
})();
